module.exports = {
    gameNetworkId:228
};


//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 40
// module chunks = 0